module.exports = __webpack_public_path__ + "logoMin.png?11c7de7c7e3343f85f03a049b8924eb7";